
import { connect } from 'react-redux';
import { PortfolioDashboard } from "./portfolio-dashboard";
import { withRouter } from 'react-router-dom'
import {loadPortfolio} from "../../superadmin/portfolio-reducer";
import {loadUserNotifications, loadUserQueueItems} from "../../superadmin/notification-reducer";
import {navigatePath} from "../../nav/actions";
import {loadIRRScores} from "../../superadmin/irr-reducer";

const mapDispatchToProps = dispatch => {
  return {
    loadPortfolio: (username, index) => dispatch(loadPortfolio(username, index)),
    loadIRRScores: () => { dispatch(loadIRRScores()) },
    loadUserNotifications: (username, index, notification_type) =>
      dispatch(loadUserNotifications(username, index, notification_type)),
    loadUserQueueItems: (username, index, queue_type) =>
      dispatch(loadUserQueueItems(username, index, queue_type)),
    navigatePath: (path, args) => dispatch(navigatePath(path, args)),
  }
};

const mapStateToProps = state => {
  return {
    portfolio: state.portfolio,
    token: state.user.token,
    client: state.client,
    notification: state.notification,
    irr: state.irr,
  }
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PortfolioDashboard));
